export default "https://cdn-static.gokick.com/assets/9232f824e6a46c896411df64bf74cb68df4bd809/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";